export default {
  LanguageList: [
    { value: "en", label: "English" },
    { value: "cn", label: "简体中文" },
    { value: "tc", label: "繁體中文" },
    // { value: "jp", label: "日本語" },
  ],
  countryOptions: [
    {
      value: "NZ",
      label: "New Zealand",
      key: "NZ",
    },
    {
      value: "TR",
      key: "TR",
      label: "Turkey",
    },
    {
      value: "DK",
      key: "DK",
      label: "Denmark",
    },
    {
      value: "MO",
      key: "MO",
      label: "Macau, China",
    },
    {
      value: "CA",
      key: "CA",
      label: "Canada",
    },
    {
      value: "MY",
      key: "MY",
      label: "Malaysia",
    },
    {
      value: "SE",
      key: "SE",
      label: "Sweden",
    },
    {
      value: "NO",
      key: "NO",
      label: "Norway",
    },
  ],
  individualTypeOptions: [
    {
      value: "a 25% owner",
      label: "Option.IndividualType.Owner.Label",
      key: "Option.IndividualType.Owner.Label",
    },
    {
      value: "a control person",
      label: "Option.IndividualType.Person.Label",
      key: "Option.IndividualType.Person.Label",
    },
    {
      value: "both a 25% owner and a control person",
      label: "Option.IndividualType.Both.Label",
      key: "Option.IndividualType.Both.Label",
    },
  ],
  identificationTypeOptions: [
    {
      value: 'U.S. social security number ("SSN")',
      label: "Option.IdentificationType.SSN.Label",
      key: "Option.IdentificationType.SSN.Label",
    },
    {
      value: 'U.S. Tax Identification number ("TIN")',
      label: "Option.IdentificationType.TIN.Label",
      key: "Option.IdentificationType.TIN.Label",
    },
    {
      value: 'U.S. Alien Identification number ("AID")',
      label: "Option.IdentificationType.AID.Label",
      key: "Option.IdentificationType.AID.Label",
    },
    {
      value: 'Individual does not have an "SSN", "tin", or "AID"',
      label: "Option.IdentificationType.No.Label",
      key: "Option.IdentificationType.No.Label",
    },
  ],
  employStatusOptions: [
    {
      value: "Employed",
      label: "Option.EmploymentStatus.Employed.Label",
      key: "Employed",
    },
    {
      value: "Self-employed/Business Owner",
      label: "Option.EmploymentStatus.SelfEmployed.Label",
      key: "SelfEmployed",
    },
    {
      value: "Unemployed",
      label: "Option.EmploymentStatus.Unemployed.Label",
      key: "Unemployed",
    },
    {
      value: "Retired",
      label: "Option.EmploymentStatus.Retired.Label",
      key: "Retired",
    },
    {
      value: "Others",
      label: "Option.EmploymentStatus.Others.Label",
      key: "Others",
    },
  ],
  sourceFundsOptions: [
    {
      value: "Employment compensation",
      label: "Option.SourceFunds.EmploymentCompensation.Label",
      key: "Option.SourceFunds.EmploymentCompensation.Label",
    },
    {
      value: "Self-employed/Business Income",
      label: "Option.SourceFunds.SelfEmployed.Label",
      key: "Option.SourceFunds.SelfEmployed.Label",
    },
    {
      value: "Investment income",
      label: "Option.SourceFunds.InvestmentIncome.Label",
      key: "Option.SourceFunds.InvestmentIncome.Label",
    },
    {
      value: "Retirement income",
      label: "Option.SourceFunds.RetirementIncome.Label",
      key: "Option.SourceFunds.RetirementIncome.Label",
    },
    {
      value: "Token issuance/ICO",
      label: "Option.SourceFunds.TokenIssuance.Label",
      key: "Option.SourceFunds.TokenIssuance.Label",
    },
    {
      value: "Others",
      label: "Option.SourceFunds.Others.Label",
      key: "Option.SourceFunds.Others.Label",
    },
  ],
  tradingPurposeOptions: [
    {
      value: "Commerce",
      label: "Option.TradingPurpose.Commerce.Label",
      key: "Option.TradingPurpose.Commerce.Label",
    },
    {
      value: "Real Estate Purchase",
      label: "Option.TradingPurpose.RealEstate.Label",
      key: "Option.TradingPurpose.RealEstate.Label",
    },
    {
      value: "Individual Need",
      label: "Option.TradingPurpose.IndividualNeed.Label",
      key: "Option.TradingPurpose.IndividualNeed.Label",
    },
    {
      value: "Investment",
      label: "Option.TradingPurpose.Investment.Label",
      key: "Option.TradingPurpose.Investment.Label",
    },
    {
      value: "Education & Living",
      label: "Option.TradingPurpose.EducationLiving.Label",
      key: "Option.TradingPurpose.EducationLiving.Label",
    },
    {
      value: "Others",
      label: "Option.TradingPurpose.Others.Label",
      key: "Option.TradingPurpose.Others.Label",
    },
  ],
  ECPCapacityOptions: [
    {
      value: "Financial institution",
      label: "Option.ECPCapacity.FinancialInstitution.Label",
      key: "Option.ECPCapacity.FinancialInstitution.Label",
    },
    {
      value: "Regulated insurance company",
      label: "Option.ECPCapacity.RegulatedInsuranceCompany.Label",
      key: "Option.ECPCapacity.RegulatedInsuranceCompany.Label",
    },
    {
      value: "Investment company",
      label: "Option.ECPCapacity.InvestmentCompany.Label",
      key: "Option.ECPCapacity.InvestmentCompany.Label",
    },
    {
      value: "Commodity pool",
      label: "Option.ECPCapacity.CommodityPool.Label",
      key: "Option.ECPCapacity.CommodityPool.Label",
    },
    {
      value: "Entity meeting required asset/net worth and contract",
      label: "Option.ECPCapacity.EntityMeeting.Label",
      key: "Option.ECPCapacity.EntityMeeting.Label",
    },
    {
      value: "Obligation",
      label: "Option.ECPCapacity.Obligation.Label",
      key: "Option.ECPCapacity.Obligation.Label",
    },
    {
      value: "Employee benefit plan",
      label: "Option.ECPCapacity.EmployeeBenefitPlan.Label",
      key: "Option.ECPCapacity.EmployeeBenefitPlan.Label",
    },
    {
      value: "Governmental entity",
      label: "Option.ECPCapacity.GovernmentalEntity.Label",
      key: "Option.ECPCapacity.GovernmentalEntity.Label",
    },
    {
      value: "Broker or dealer",
      label: "Option.ECPCapacity.BrokerOrDealer.Label",
      key: "Option.ECPCapacity.BrokerOrDealer.Label",
    },
    {
      value: "Associated person of a registered broker or dealer",
      label: "Option.ECPCapacity.AssociatedPerson.Label",
      key: "Option.ECPCapacity.AssociatedPerson.Label",
    },
    {
      value: "Futures commission merchant",
      label: "Option.ECPCapacity.FuturesCommissionMerchant.Label",
      key: "Option.ECPCapacity.FuturesCommissionMerchant.Label",
    },
    {
      value: "Floor broker or trader",
      label: "Option.ECPCapacity.FloorBrokerOrTrader.Label",
      key: "Option.ECPCapacity.FloorBrokerOrTrader.Label",
    },
    {
      value: "Individual",
      label: "Option.ECPCapacity.Individual.Label",
      key: "Option.ECPCapacity.Individual.Label",
    },
    {
      value: "Investment adviser",
      label: "Option.ECPCapacity.InvestmentAdviser.Label",
      key: "Option.ECPCapacity.InvestmentAdviser.Label",
    },
    {
      value: "Others",
      label: "Option.ECPCapacity.Others.Label",
      key: "Option.ECPCapacity.Others.Label",
    },
  ],
  bankTypeOptions: [
    {
      value: "U.S.-based USD",
      label: "Option.BankAccountType.USBased.Label",
      key: "Option.BankAccountType.USBased.Label",
    },
    {
      value: "U.S.-based USD",
      label: "Option.BankAccountType.NonUSBased.Label",
      key: "Option.BankAccountType.NonUSBased.Label",
    },
  ],
  tokenIssuanceTypeOptions: [
    {
      value: "SAFT",
      label: "Option.TokenIssuanceType.SAFT.Label",
      key: "Option.TokenIssuanceType.SAFT.Label",
    },
    {
      value: "Other private sale",
      label: "Option.TokenIssuanceType.OtherPrivateSale.Label",
      key: "Option.TokenIssuanceType.SAFT.Label",
    },
    {
      value: "Public sale",
      label: "Option.TokenIssuanceType.PublicSale.Label",
      key: "Option.TokenIssuanceType.PublicSale.Label",
    },
  ],
  assetsSourceOptions: [
    {
      value: "Revenue",
      label: "Option.AssetsSource.Revenue.Label",
      key: "Option.AssetsSource.Revenue.Label",
    },
    {
      value: "GP contributed capital",
      label: "Option.AssetsSource.GP.Label",
      key: "Option.AssetsSource.GP.Label",
    },
    {
      value: "LP Investment",
      label: "Option.AssetsSource.LP.Label",
      key: "Option.AssetsSource.LP.Label",
    },
    {
      value: "Token Issuance / ICO",
      label: "Option.AssetsSource.Token.Label",
      key: "Option.AssetsSource.Token.Label",
    },
    {
      value: "Others",
      label: "Option.AssetsSource.Others.Label",
      key: "Option.AssetsSource.Others.Label",
    },
  ],
  cryptoCurrencyOptions: [
    // { label: "Option.BTC.Others.Label", value: "BTC", key: "BTC" },
    // { label: "Option.ETH.Others.Label", value: "ETH", key: "ETH" },
    //{ label: "Option.USDC.Others.Label", value: "USDC", key: "USDC" },
    { label: "Option.USDT.Others.Label", value: "USDT", key: "USDT" },
  ],
  cryptoAssetsOptions: [
    { label: "Aelf", value: "Aelf", key: "Aelf" },
    { label: "Ardor", value: "Ardor", key: "Ardor" },
    { label: "Augur", value: "Augur", key: "Augur" },
    { label: "Cardano", value: "Cardano", key: "Cardano" },
    {
      label: "Basic Attention",
      value: "Basic Attention",
      key: "Basic Attention",
    },
    { label: "Bitcoin", value: "Bitcoin", key: "Bitcoin" },
    {
      label: "Bitcoin Cash ABC",
      value: "Bitcoin Cash ABC",
      key: "Bitcoin Cash ABC",
    },
    {
      label: "Bitcoin Cash SV",
      value: "Bitcoin Cash SV",
      key: "Bitcoin Cash SV",
    },
    { label: "Bitcoin Gold", value: "Bitcoin Gold", key: "Bitcoin Gold" },
    { label: "BitShares", value: "BitShares", key: "BitShares" },
    { label: "Bytom", value: "Bytom", key: "Bytom" },
    { label: "CyberMiles", value: "CyberMiles", key: "CyberMiles" },
    { label: "Crypto.com", value: "Crypto.com", key: "Crypto.com" },
    { label: "Dash", value: "Dash", key: "Dash" },
    { label: "Decentraland", value: "Decentraland", key: "Decentraland" },
    { label: "DigiByte", value: "DigiByte", key: "DigiByte" },
    { label: "Dogecoin", value: "Dogecoin", key: "Dogecoin" },
    { label: "Elastos", value: "Elastos", key: "Elastos" },
    { label: "EOS", value: "EOS", key: "EOS" },
    { label: "Ether", value: "Ether", key: "Ether" },
    {
      label: "Ethereum Classic",
      value: "Ethereum Classic",
      key: "Ethereum Classic",
    },
    { label: "Gas", value: "Gas", key: "Gas" },
    { label: "Gemini Dollar", value: "Gemini Dollar", key: "Gemini Dollar" },
    { label: "Huobi Token", value: "Huobi Token", key: "Huobi Token" },
    { label: "ICON", value: "ICON", key: "ICON" },
    { label: "IOST", value: "IOST", key: "IOST" },
    { label: "Kyber Network", value: "Kyber Network", key: "Kyber Network" },
    { label: "Litecoin", value: "Litecoin", key: "Litecoin" },
    { label: "Lisk", value: "Lisk", key: "Lisk" },
    { label: "Metaverse ETP", value: "Metaverse ETP", key: "Metaverse ETP" },
    { label: "MIOTA", value: "MIOTA", key: "MIOTA" },
    { label: "Mithril", value: "Mithril", key: "Mithril" },
    { label: "Monero", value: "Monero", key: "Monero" },
    { label: "Nebulas", value: "Nebulas", key: "Nebulas" },
    { label: "NEM", value: "NEM", key: "NEM" },
    { label: "NEO", value: "NEO", key: "NEO" },
    { label: "Odyssey", value: "Odyssey", key: "Odyssey" },
    { label: "OmiseGO", value: "OmiseGO", key: "OmiseGO" },
    { label: "Ontology", value: "Ontology", key: "Ontology" },
    { label: "Paxos", value: "Paxos", key: "Paxos" },
    { label: "Qtum", value: "Qtum", key: "Qtum" },
    { label: "Siacoin", value: "Siacoin", key: "Siacoin" },
    { label: "Status", value: "Status", key: "Status" },
    { label: "Steem Dollars", value: "Steem Dollars", key: "Steem Dollars" },
    { label: "Stellar", value: "Stellar", key: "Stellar" },
    { label: "TenX", value: "TenX", key: "TenX" },
    { label: "Theta Token", value: "Theta Token", key: "Theta Token" },
    { label: "Tether", value: "Tether", key: "Tether" },
    { label: "TRON", value: "TRON", key: "TRON" },
    { label: "TrueUSD", value: "TrueUSD", key: "TrueUSD" },
    { label: "USD Coin", value: "USD Coin", key: "USD Coin" },
    { label: "VeChain", value: "VeChain", key: "VeChain" },
    { label: "Verge", value: "Verge", key: "Verge" },
    { label: "WaltonChain", value: "WaltonChain", key: "WaltonChain" },
    { label: "XRP", value: "XRP", key: "XRP" },
    { label: "Zcash", value: "Zcash", key: "Zcash" },
    { label: "Zilliqa", value: "Zilliqa", key: "Zilliqa" },
  ],
  estimatedTotalNumberPerMonthOptions: [
    {
      value: "0~5",
      label: "Option.EstimatedTotalNumberPerMonth.05.Label",
      key: "0~5",
    },
    {
      value: "5~10",
      label: "Option.EstimatedTotalNumberPerMonth.510.Label",
      key: "5~10",
    },
    {
      value: "10~20",
      label: "Option.EstimatedTotalNumberPerMonth.1020.Label",
      key: "10~20",
    },
    {
      value: "20~30",
      label: "Option.EstimatedTotalNumberPerMonth.2030.Label",
      key: "20~30",
    },
    {
      value: "Over 30",
      label: "Option.EstimatedTotalNumberPerMonth.Over30.Label",
      key: "Over 30",
    },
  ],
  estimatedTotalNotioanlValuePerMonthOptions: [
    {
      value: "Under 500K",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.Under500K.Label",
      key: "Under 500K",
    },
    {
      value: "500K ~1M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.500K1M.Label",
      key: "500K ~1M",
    },
    {
      value: "1M~3M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.1M3M.Label",
      key: "1M~3M",
    },
    {
      value: "3M~9M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.3M9M.Label",
      key: "3M~9M",
    },
    {
      value: "9M~15M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.9M15M.Label",
      key: "9M~15M",
    },
    {
      value: "15M~30M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.15M30M.Label",
      key: "15M~30M",
    },
    {
      value: "Over 30M",
      label: "Option.EstimatedTotalNotioanlValuePerMonth.Over30M.Label",
      key: "Over 30M",
    },
  ],
  radioYesNoOptions: [
    {
      value: "true",
      label: "Radio.Yes",
      key: "Radio.Yes",
    },
    {
      value: "false",
      label: "Radio.No",
      key: "Radio.No",
    },
  ],
};
